<template>
    <div>
      <mail-contact-type-list></mail-contact-type-list>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  
  
  